import { Component, OnInit,ElementRef, Renderer2, inject, ViewChild,AfterViewInit  } from '@angular/core';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-da-report',
  templateUrl: './da-report.component.html',
  styleUrls: ['./da-report.component.scss']
})
export class DaReportComponent implements OnInit {
  @ViewChild('dataTable', { static: false }) dataTable: ElementRef;
  private document = inject(DOCUMENT)
  spinner: boolean;
  customers: any = [];
  dtOptions: any = {};
  tableshow: boolean = false;
  regob:any;
  dashboardcarddata: any;
constructor( private el: ElementRef,
  private renderer: Renderer2,
            public ApiService: ApiServiceService,
            private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.getdata();
    this.showSpinner();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[3, 'asc']],
      dom: 'lBfrtip',
        buttons: [
          {
            extend: 'print',
            title:'<h4 style="text-align: center; font-size: 24px;font-weight: bold;">DISTRICT-WISE ENROLLMENT REPORT</h4>',
            // footer: '<h4 style="text-align: center; font-size: 24px;">DMK Engineers Wing Portal</h4>',
            footer: true, // Enable the footer
            customize: function (win) {
              // Add custom styling or content to the print window
              const footer = win.document.createElement('div'); // Create a new footer element    
              // Create the custom footer content
              footer.innerHTML = '<h4 style="text-align: center;">DMK Engineering Wing</h4>';
              // Append the custom footer to the print window's body
              win.document.body.appendChild(footer);
            }
          }
        ],
    };
    this.addPrintStyles();
    this.applyStylesToDOMElement();
  }
  ngAfterViewInit() {
  // this.printTable();
    // Call the printTable function here, ensuring that the view has been initialized.
  }

  applyStylesToDOMElement() {

    const appObReportButton = this.document.getElementsByTagName('app-da-report')[0].getElementsByTagName('button');
    var a=appObReportButton
    // console.log(this.document.getElementsByClassName());
    // if (appObReportButton) {
    //   this.renderer.setStyle(appObReportButton.parentElement, 'position', 'absolute');
    //   this.renderer.setStyle(appObReportButton.parentElement, 'right', '0px');
    //   this.renderer.setStyle(appObReportButton.parentElement, 'top', '0px');
    // }
  }
  getdata() {
    this.spinner = true;
    this.ApiService.report_da().subscribe((data) => {
      for (const prop in data) {
        this.customers.push(data[prop]);
      }
      console.log(data)
      this.tableshow = true;
      this.spinner = false;
    });
  }
  public showSpinner(): void {
    // this.spinner = true;
    this.spinnerService.show();
  }

    private addPrintStyles() {
      const head = document.getElementsByTagName('body')[0];
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
        @media print {
          body * {
            visibility: visible;
          }
        }
      `;

      head.appendChild(style);
    }
    printTable() {
      const printContents = this.dataTable.nativeElement.outerHTML;
      const popupWin = window.open('', '_blank', 'width=600,height=600');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print Table</title>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    }
}